import { render, staticRenderFns } from "./ztTable.vue?vue&type=template&id=2f848e41&scoped=true"
import script from "./ztTable.vue?vue&type=script&lang=js"
export * from "./ztTable.vue?vue&type=script&lang=js"
import style0 from "../../../../styles/components/ztTable.css?vue&type=style&index=0&id=2f848e41&prod&lang=css&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../web-empleado/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f848e41",
  null
  
)

export default component.exports